import React from 'react';
import clsx from 'clsx';
import useStyles from './styles';
import { StandardProps } from '@material-ui/core';

export type ColorfulBarClassKey = 'root' | 'gutters';

export type ColorfulBarProps = {
    /** If true, disables gutter padding. */
    disableGutters?: boolean;
};

const ColorfulBar: React.FC<StandardProps<ColorfulBarProps, ColorfulBarClassKey>> = ({
    className,
    disableGutters = false,
}) => {
    const classes = useStyles();
    return <div className={clsx(classes.root, { [classes.gutters]: !disableGutters }, className)} />;
};

export default ColorfulBar;
